import React from "react";
import { Info } from "lucide-react";

// Inline, non-blocking note shown when a package is selected with < 50 guests.
export const GuestMinimumNotice = ({ active }) => {
  if (!active) return null;
  return (
    <div
      data-testid="guest-min-inline"
      role="status"
      className="mt-3 flex max-w-xl items-start gap-2 rounded-xl border border-amber-300 bg-amber-50 p-3 text-xs leading-relaxed text-amber-900"
    >
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-600" aria-hidden />
      <span>
        Our packages start at 50 guests. For smaller quantities our team will follow
        up with a suitable proposal — you can still continue and submit this enquiry.
      </span>
    </div>
  );
};
